import noUiSlider from "noUiSlider";

class PriceSlider extends HTMLElement {
  constructor() {
    super();

    // Object to store all selectors used in the component
    this.selectors = {
      minBox: "input[data-start]",
      maxBox: "input[data-end]",
      priceSlider: ".priceSlider",
    };

    // Initialize DOM elements using the selectors
    this.minBox = this.querySelector(this.selectors.minBox);
    this.maxBox = this.querySelector(this.selectors.maxBox);
    this.slider = this.querySelector(this.selectors.priceSlider);

    this.isPriceFilterOn = false;
  }

  // Called when the element is added to the DOM
  async connectedCallback() {
    // Create the noUiSlider with the specified range and initial values
    noUiSlider.create(this.slider, {
      start: [
        parseFloat(this.minBox.value) || 0,
        parseFloat(this.maxBox.value) || 0,
      ],
      connect: true,
      step: 0.01,
      range: {
        min: parseFloat(this.minBox.dataset.start) || 0,
        max: parseFloat(this.maxBox.dataset.end) || 0,
      },
    });

    // Update min and max values on slider change
    this.slider.noUiSlider.on("update", (values, handle) => {
      const value = parseFloat(values[handle]).toFixed(2);

      if (handle === 0) {
        this.minBox.value = value;
      } else {
        this.maxBox.value = value;
      }
    });

    this.minBox.addEventListener("change", (event) => {
      this.slider.noUiSlider.set([parseFloat(event.target.value), null]);
    });

    this.maxBox.addEventListener("change", (event) => {
      this.slider.noUiSlider.set([null, parseFloat(event.target.value)]);
    });
  }

  reset() {
    const min = parseFloat(this.minBox.dataset.start) || 0;
    const max = parseFloat(this.maxBox.dataset.end) || 0;
    this.slider.noUiSlider.set([min, max]);
  }
}

customElements.define("price-slider", PriceSlider);

// Global reset filter handler
window.resetFilters = (resetBtn) => {
  const filterGroup = resetBtn.closest(".filter-group");
  const filterType = resetBtn.dataset.filterType;

  if (filterType === "list") {
    const inputs = filterGroup.querySelectorAll(
      'input[type="radio"], input[type="checkbox"]',
    );
    inputs.forEach((input) => {
      input.checked = false;
    });
  } else if (filterType === "price_range") {
    const priceSlider = filterGroup.querySelector("price-slider");
    if (priceSlider) {
      priceSlider.reset();
    }
  }
};

document.addEventListener("click", (event) => {
  if (event.target.classList.contains("js-reset-filter")) {
    window.resetFilters(event.target);
  }
});


document.addEventListener("DOMContentLoaded", function () {

  const drawerLinks = document.querySelectorAll('a[data-drawer]');
  const checkboxes = document.querySelectorAll('#sorter-drawer, #filters-drawer');

  drawerLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.dataset.drawer;
      const targetCheckbox = document.getElementById(targetId);

      // stato attuale prima del reset
      const isAlreadyOpen = targetCheckbox.checked;

      // chiudi tutto
      checkboxes.forEach(cb => cb.checked = false);

      // se NON era già aperto → riapri
      if (!isAlreadyOpen) {
        targetCheckbox.checked = true;
      }
    });
  })
});
